import { Row, Col, Card, CardBody, Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"

const PageWrapper = ({
  title,
  breadcrumbItem,
  children,
  fluid = true,
  cardBody = true,
  showBreadcrumb = true,
  className = "page-content",
  cardBodyClassName = "",
}) => {
  return (
    <div className={className}>
      <Container fluid={fluid}>
        {showBreadcrumb && (
          <Breadcrumbs title={title} breadcrumbItem={breadcrumbItem} />
        )}
        {cardBody ? (
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className={cardBodyClassName}>{children}</CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          children
        )}
      </Container>
    </div>
  )
}

export default PageWrapper
